/* RESPONSIBLE TEAM: team-proactive-support */
interface PerformanceSettings {
  throttle: number;
}

interface OptionalPerformanceSettings {
  throttle?: number;
}

const DEFAULT_PERFORMANCE_SETTINGS: PerformanceSettings = {
  throttle: 25,
};

export { PerformanceSettings, OptionalPerformanceSettings, DEFAULT_PERFORMANCE_SETTINGS };
